import { render, staticRenderFns } from "./AccountUserDetailsDialog.vue?vue&type=template&id=0353fdc3&scoped=true&"
import script from "./AccountUserDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./AccountUserDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353fdc3",
  null
  
)

export default component.exports